/*
 * @Author: Huangxianlong
 * @Date: 2023-08-11 16:44:08
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2024-08-15 11:29:18
 * @FilePath: \monitor\src\language\user\alarm.js
 * @Description: 
 */
const info = {
  CN: {
    dataloggerName: "采集器名称",
    alarmLevel: "报警级别",
    alarmLevelPla: "请选择报警级别",
    earlyWarning: "预警",
    warn: "警告",
    dangerous: "危险",
    offline: "离线",
    alarmContent: "报警详情",
    alarmTime: "报警时间",
    emailStatus: "邮件状态",
    
  },
  EN: {
    dataloggerName: "DataLogger Name",
    alarmLevel: "Alarm Level",
    alarmLevelPla: "Please select an alarm level",
    earlyWarning: "Early Warning",
    warn: "Warn",
    dangerous: "Dangerous",
    offline: "offline",
    alarmContent: "Alarm Details",
    alarmTime: "Alarm Time",
    emailStatus: "Email Status",
  }
};
export default info; //需要暴露出去



// WEBPACK FOOTER //
// ./src/language/user/alarm.js